import { Link } from 'react-router-dom';
import type { ContentItem } from '@/types/content';
import SectionTitle from '@/components/base/SectionTitle';
import { getDetailPath } from '@/utils/content';

interface LifePicksProps {
  items: ContentItem[];
}

export default function LifePicks({ items }: LifePicksProps) {
  return (
    <section className="mt-10 bg-background-200/60 py-10 md:mt-14 md:py-14">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <SectionTitle
          title="生活服务推荐"
          subtitle="一站式便捷服务 · 让日常更省心"
          icon="ri-home-smile-2-line"
          moreTo="/category/life"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.slice(0, 3).map((item) => (
            <Link
              key={item.id}
              to={getDetailPath(item)}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
            >
              <div className="h-44 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-medium text-accent-800">
                    {item.serviceType}
                  </span>
                  <span className="text-[11px] text-secondary-400">{item.area}</span>
                </div>
                <h3 className="mt-2 line-clamp-1 font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
                  {item.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-secondary-500">{item.summary}</p>
                <div className="mt-auto flex items-center justify-between pt-3">
                  <span className="text-base font-bold text-accent-600">{item.price}</span>
                  <span className="flex items-center gap-1 text-xs text-secondary-500 transition-colors group-hover:text-accent-600">
                    查看详情
                    <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}